import React, { useState, useEffect, Fragment } from "react";
import Swal from 'sweetalert2';
import { Tab, Nav, Button, Card, Row, Col, FormGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from "react-redux";

import config from "../../config";
import navigation from "../../navigation";

import { useAuth } from "../../Hooks/UseAuth";
import { useQuery } from "../../Hooks/UseQuery";
import useTranslation from "../../Hooks/UseTranslation";

import SessionActions from "../../Redux/Actions/SessionActions";
import SessionService from "../../Services/SessionService";

import InterfaceActions from "../../Redux/Actions/InterfaceActions";
import ProjectsActions from "../../Redux/Actions/ProjectsActions";

import InputFormControl from "../../Components/InputFormControl/InputFormControl";
import Toast from "../../Components/Toast/Toast";
import AvatarUploader from "../../Components/AvatarUploader/AvatarUploader";
import { setLanguage } from "../../Redux/Actions/TranslationsActions";
import ProjectLayout from "@/Layouts/MainLayout/ProjectLayout";
import ContentHeader from "@/Layouts/MainLayout/components/ContentHeader";
import ContentBody from "@/Layouts/MainLayout/components/ContentBody";
import Switch from "react-bootstrap/esm/Switch";

import './ProfilePage.scss'

const ProfilePage = () => {

  const { t, language } = useTranslation();

  const { userData, update, logout, notificationsSettings, setNotificationsSetting } = useAuth()

  // console.log('notificationsSettings', notificationsSettings)

  const query = useQuery();
  const project_id = query.get("project_id");

  const dispatch = useDispatch();

  const project = useSelector((state: any) => state.ProjectsReducer.rowData);
  const loadProjectStatus = useSelector(
    (state: any) => state.ProjectsReducer.loadRowStatus
  );

  const [ newUserData, setNewUserData ] = useState({
    name: userData?.name ?? "",
    surname: userData?.surname ?? "",
    email: userData?.email ?? "",
    phone: userData?.phone ?? "",
    workPhone: userData?.workPhone ?? "",
    address: userData?.address ?? "",
    avatar: userData?.avatar ?? "",
    account: userData?.account ?? "",
   });

  const [ avatarUploaded, setAvatarUploaded ] = useState<any>({});

  const [ editable, setEditable ] = useState(false);
  const [ editablePass, setEditablePass ] = useState(false);

  const [ updating, setUpdating ] = useState(false);
  const [ changingPassword, setChangingPassword ] = useState(false);

  const [ pass, setPass ] = useState({
    actual: "",
    new: "",
    new2: "",
  });

  //CODIGO NUEVO
  const [ tab, setTab ] = useState('USUARIO')
  const changeTab = (tab: string) => {

    if (!editable) {

      setTab(tab)
    }
  }
  //CODIGO NUEVO
  const [ menu, submenu ] = navigation.getNavigation(
    project ? project._id : null,
    "",
    ""
  );

  const loadProject = () => {
    if (loadProjectStatus !== "none") return;

    if (!project_id) return;

    dispatch(ProjectsActions.getRowAction(project_id));
  };
  loadProject();

  const reset = () => {
    setEditable(false);
  };

  const resetPass = () => {
    setPass({
      actual: "",
      new: "",
      new2: "",
    });

    setEditablePass(false);
  };

  const handleUpdate = async () => {
    dispatch(InterfaceActions.showLoader());

    setUpdating(true);

    await update({
      name: newUserData.name,
      surname: newUserData.surname,
      phone: newUserData.phone,
      workPhone: newUserData.workPhone,
      address: newUserData.address,
      avatar: avatarUploaded._id ? avatarUploaded : newUserData.avatar,
    })

    Toast.show(
      t('PROFILE:ProfileUpdatedToastTitle'),
      t('PROFILE:ProfileUpdatedToastContent')
    )

    setUpdating(false);

    dispatch(InterfaceActions.hideLoader());

    setEditable(false);
  };

  const changePassword = async () => {
    if (!pass.actual || !pass.new || !pass.new2) {
      Toast.show(
        t('PROFILE:UpdatePasswordMissingDataToastTitle'),
        t('PROFILE:UpdatePasswordMissingDataToastContent')
      );
      return;
    }

    if (pass.new !== pass.new2) {
      Toast.show(
        t('PROFILE:UpdatePasswordNoMatchingToastTitle'),
        t('PROFILE:UpdatePasswordNoMatchingToastContent')
      );
      return;
    }

    dispatch(InterfaceActions.showLoader());

    setChangingPassword(true);

    await dispatch(SessionActions.changePasswordAction(pass.actual, pass.new));

    setChangingPassword(false);

    dispatch(InterfaceActions.hideLoader());

    setEditablePass(false);

    setPass({
      actual: "",
      new: "",
      new2: "",
    });
  };

  const handleChangeLanguage = async (language: string) => {

    dispatch(InterfaceActions.showLoader());

    await dispatch(SessionActions.changeLanguageAction(language));

    await dispatch(setLanguage(language))

    dispatch(InterfaceActions.hideLoader());
  }

  const onUploadAvatar = (image: any) => {

    setNewUserData({ ...newUserData, avatar: image.fullPath });

    setAvatarUploaded(image);
  };

  const handleEliminarCuenta = () => {

    Swal.fire({
      title: t('PROFILE:DeleteAccountModalTitle'),
      text: t('PROFILE:DeleteAccountModalContent'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('PROFILE:DeleteAccountModalAcceptButton'),
      cancelButtonText: t('PROFILE:DeleteAccountModalCancelButton'),
    }).then(async (result) => {

      if (result.isConfirmed) {

        dispatch(InterfaceActions.showLoader())

        const { error } = await SessionService.deleteAccount()

        if (error) {

          dispatch(InterfaceActions.hideLoader())

          if (error === 'transfer_projects_first') {

            Swal.fire({
              text: t('PROFILE:DeleteAccountTransferFirstTitle'),
              icon: 'info',
              confirmButtonText: t('PROFILE:DeleteAccountTransferFirstAccept'),
            })
          }

          return
        }

        logout()

        dispatch(InterfaceActions.hideLoader())

        Swal.fire(
          t('PROFILE:AccountDeletedTitle'),
          t('PROFILE:AccountDeletedContent'),
          'success'
        );
      }
    });
  };

  const handleChangeNotificationSetting = async (key: string, value: boolean) => {

    dispatch(InterfaceActions.showLoader());

    await dispatch(SessionActions.changeNotificationSettingAction(key, value));

    setNotificationsSetting(key, value)

    dispatch(InterfaceActions.hideLoader());
  }

  useEffect(() => {
    // Check if the "Cambiar contraseña" option is selected and the input is editable
    if (tab === 'CONFIGURACION' && editablePass) {
      // Focus on the input field for the current password
      document.getElementById('currentPasswordInput')?.focus();
    }
  }, [tab, editablePass]);

  return (
    <ProjectLayout menuName="profile" subMenuName="">
      <ContentHeader
        title={t('PROFILE:PageTitle')}
        subtitle={t('PROFILE:PageSubtitle')}
        className="profile-content-header"
      >
        <div className="ul-widget__head-toolbar profile-header-toolbar">
          <div className="text-right profile-header-edit-actions">
            <Fragment>
              {tab === 'USUARIO' && !editable && (
                <button
                  className="profile-header-tab-button"
                  onClick={() => setEditable(true)}
                >
                  <span className="icon-editar"></span> {t('PROFILE:PageEditButton')}
                </button>
              )}
            </Fragment>
            <Fragment>
              {tab === 'CONFIGURACION' && !editablePass && (
                <button
                  className="profile-header-tab-button"
                  onClick={() => setEditablePass(true)}>
                  <span className="icon-editar"></span> {t('PROFILE:ChangePasswordButton')}
                </button>
              )}
              {tab === 'CONFIGURACION' && editablePass && (
                <Fragment>
                  <button
                    className="profile-header-tab-button"
                    onClick={() => resetPass()}>
                    <span className="icon-cancelar"></span> {t('PROFILE:UpdatePasswordCancelButton')}
                  </button>
                  <button
                    className="profile-header-tab-button is-primary"
                    onClick={() => changePassword()}>
                    <span className="icon-guardar"></span>{" "}
                    {changingPassword
                      ? t('PROFILE:UpdatePasswordSaveButtonSaving')
                      : t('PROFILE:UpdatePasswordSaveButtonIdle')}
                  </button>
                </Fragment>
              )}
            </Fragment>
          </div>
        </div>
        <div className="ul-widget__head-nav profile-header-nav">
          <Tab.Container>
           <Nav as="ul" className="profile-tabs nav-tabs nav-tabs-line nav-tabs-bold">
             <Nav.Item as="li">
               <Nav.Link active={tab === 'USUARIO'} onClick={() => changeTab('USUARIO')}>
                 <span className="icon-usuario"></span> <span className="hide-on-mobile"> {t('PROFILE:UserTab')}</span>
               </Nav.Link>
             </Nav.Item>
             <Nav.Item as="li">
               <Nav.Link active={tab === 'CONFIGURACION'} onClick={() => changeTab('CONFIGURACION')}>
                 <span className="icon-configuracion"></span>  <span className="hide-on-mobile"> {t('PROFILE:SettingsTab')}</span>
               </Nav.Link>
             </Nav.Item>
             <Nav.Item as="li">
               <Nav.Link active={tab === 'NOTIFICACIONES'} onClick={() => changeTab('NOTIFICACIONES')}>
                 <span className="icon-notificaciones"></span>  <span className="hide-on-mobile"> {t('PROFILE:NotificationsTab')}</span>
               </Nav.Link>
             </Nav.Item>
           </Nav>
         </Tab.Container>
        </div>
      </ContentHeader>
      <ContentBody>
        <Tab.Content className='no-padding profile-page'>
          <Tab.Pane className="pl4-profile-user-pane" active={tab === 'USUARIO'}>
            <Row className="justify-content-md-center">
              <div className="col-md-5 pb-3 profile-main-column" >
              <div className="card profile-card-main">
                <div className="card-body">
                  <div className="row profile-card-grid">
                    <div className="col-lg-5 mb-2 profile-avatar-panel">
                      <AvatarUploader
                        mode="html5-canvas-upload"
                        baseUrl={config.apiHost}
                        endpoint={`/upload/canvas`}
                        image={newUserData.avatar ?? ""}
                        onUpload={(image: string) => onUploadAvatar(image)}
                        disabled={!editable}
                      />
                      <div className="profile-name">{newUserData.account}</div>
                      <div className="profile-email">{newUserData.email}</div>
                    </div>
                    <div className="col-lg-7 profile-form-panel">
                      <div className="form-group row">
                        <label htmlFor="" className="col-xl-4 col-form-label">
                          Nombres
                        </label>
                        <div className="col-xl-8">
                          <InputFormControl
                            value={newUserData.name}
                            onChange={(value: string) =>
                              setNewUserData({ ...newUserData, name: value })
                            }
                            readOnly={!editable}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="" className="col-xl-4 col-form-label">
                          Apellidos
                        </label>
                        <div className="col-xl-8">
                          <InputFormControl
                            value={newUserData.surname}
                            onChange={(value: string) =>
                              setNewUserData({ ...newUserData, surname: value })
                            }
                            readOnly={!editable}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="" className="col-xl-4 col-form-label">
                          Teléfono Personal
                        </label>
                        <div className="col-xl-8">
                          <InputFormControl
                            type="phone"
                            value={newUserData.phone}
                            onChange={(value: string) =>
                              setNewUserData({ ...newUserData, phone: value })
                            }
                            readOnly={!editable}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="" className="col-xl-4 col-form-label">
                          Teléfono Laboral
                        </label>
                        <div className="col-xl-8">
                          <InputFormControl
                            type="phone"
                            value={newUserData.workPhone || ""}
                            onChange={(value: string) =>
                              setNewUserData({ ...newUserData, workPhone: value })
                            }
                            readOnly={!editable}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="" className="col-xl-4 col-form-label">
                          Dirección
                        </label>
                        <div className="col-xl-8">
                          <textarea
                            className="form-control"
                            rows={3}
                            defaultValue={newUserData.address || ""}
                            onChange={(
                              e: React.ChangeEvent<HTMLTextAreaElement>
                            ) =>
                              setNewUserData({
                                ...newUserData,
                                address: e.target.value,
                              })
                            }
                            readOnly={!editable}></textarea>
                        </div>
                      </div>
                      {editable && (
                        <div className="profile-card-actions">
                          <button
                            className="pl4-btn pl4-btn-secondary"
                            onClick={() => reset()}
                            disabled={updating}
                          >
                            <span className="icon-cancelar"></span> {t('PROFILE:PageCancelButton')}
                          </button>
                          <button
                            className="pl4-btn pl4-btn-primary"
                            onClick={() => handleUpdate()}
                            disabled={updating}
                          >
                            <span className="icon-guardar"></span>{" "}
                            {updating
                              ? t('PROFILE:PageSaveButtonSaving')
                              : t('PROFILE:PageSaveButtonIdle')}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </Row>
          </Tab.Pane>
          <Tab.Pane className="pl4-profile-settings-pane" active={tab === 'CONFIGURACION'}>
            <Row className="justify-content-md-center">
             <div className="col-md-4 pb-3">
               <Card>
                 <Card.Body>
                   <h5 className="card-title mb-3">{t('PROFILE:ChangeLanguageTitle')}</h5>
                   <div className="form-group">
                     <label htmlFor="languageSelect">
                       {t('PROFILE:ChangeLanguageLabel')}
                     </label>
                     <select
                       id="languageSelect"
                       value={language}
                       className="form-control"
                       onChange={(e) => {
                         const selectedLanguage = e.target.value;
                        // Add your logic to change the language here

                         handleChangeLanguage(selectedLanguage);
                       }}
                     >
                       <option value="es">Español</option>
                       <option value="en">English</option>
                     </select>
                   </div>
                 </Card.Body>
               </Card>
             </div>
           </Row>

           <Row className="justify-content-md-center">
             <div className="col-md-4 pb-3">
               <div className="card">
                 <div className="card-body">
                   <h5 className="card-title mb-3">
                     {t('PROFILE:ChangePasswordTitle')}
                   </h5>
                   <div className="form-group row">
                     <label htmlFor="" className="col-sm-5 col-form-label">
                       {t('PROFILE:ChangePasswordCurrentLabel')}
                     </label>
                     <div className="col-sm-7">
                       <InputFormControl
                         type="password"
                         id="currentPasswordInput" // Add this line
                         placeholder={t('PROFILE:ChangePasswordCurrentPlaceholder')}
                         value={pass.actual}
                         onChange={(value: string) => setPass({ ...pass, actual: value })}
                         readOnly={!editablePass}
                         autoFocus
                       />
                     </div>
                   </div>
                   <div className="form-group row">
                     <label htmlFor="" className="col-sm-5 col-form-label">
                       {t('PROFILE:ChangePasswordNewLabel')}
                     </label>
                     <div className="col-sm-7">
                       <InputFormControl
                         type="password"
                         placeholder={t('PROFILE:ChangePasswordNewPlaceholder')}
                         value={pass.new}
                         onChange={(value: string) =>
                           setPass({ ...pass, new: value })
                         }
                         readOnly={!editablePass}
                       />
                     </div>
                   </div>
                   <div className="form-group row">
                     <label htmlFor="" className="col-sm-5 col-form-label">
                       {t('PROFILE:ChangePasswordReNewLabel')}
                     </label>
                     <div className="col-sm-7">
                       <InputFormControl
                         type="password"
                         placeholder={t('PROFILE:ChangePasswordReNewPlaceholder')}
                         value={pass.new2}
                         onChange={(value: string) =>
                           setPass({ ...pass, new2: value })
                         }
                         readOnly={!editablePass}
                       />
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </Row>
           <Row className="justify-content-md-center">
             <div className="col-md-4 pb-3">
               <Card>
                 <Card.Body>
                   <h5 className="card-title mb-3">
                     {t('PROFILE:DeleteAccountTitle')}
                   </h5>
                   <p className="pb-2">
                     {t('PROFILE:DeleteAccountContent')}
                   </p>
                   <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                     <Button className="pl4-btn pl4-btn-danger" variant="outline-danger" onClick={handleEliminarCuenta}>
                       {t('PROFILE:DeleteAccountButton')}
                     </Button>
                   </div>
                 </Card.Body>
               </Card>
             </div>
           </Row>
          </Tab.Pane>
          <Tab.Pane className="pl4-profile-notifications-pane" active={tab === 'NOTIFICACIONES'}>
            <Row className="justify-content-md-center">
              <Col md={5} className="pl4-profile-notifications">
                <Card className="mb-3">
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      <h5 className="card-title mb-3">
                        {t('PROFILE_NOTIFICATIONS:ProjectsTitle')}
                      </h5>
                    </div>
                    <p className="pb-2">
                      {t('PROFILE_NOTIFICATIONS:ProjectsContent')}
                    </p>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:InvitationToProjectsLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.invitation_to_projects !== false}
                          onChange={(e) => handleChangeNotificationSetting('invitation_to_projects', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:InvitationToProjectsContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:ProjectAbandonmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.project_abandonment !== false}
                          onChange={(e) => handleChangeNotificationSetting('project_abandonment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:ProjectAbandonmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:ProjectAssignmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.project_assignment !== false}
                          onChange={(e) => handleChangeNotificationSetting('project_assignment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:ProjectAssignmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:ProjectDeletionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.project_deletion !== false}
                          onChange={(e) => handleChangeNotificationSetting('project_deletion', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:ProjectDeletionContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TeamMembersAdditionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.team_members_addition !== false}
                          onChange={(e) => handleChangeNotificationSetting('team_members_addition', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TeamMembersAdditionContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:AnotherTeamAssignmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.another_team_assignment !== false}
                          onChange={(e) => handleChangeNotificationSetting('another_team_assignment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:AnotherTeamAssignmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TeamMembersDeletionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.team_members_deletion !== false}
                          onChange={(e) => handleChangeNotificationSetting('team_members_deletion', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TeamMembersDeletionContent')}
                      </p>
                    </FormGroup>
                  </Card.Body>
                </Card>
                <Card className="mb-3">
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      <h5 className="card-title mb-3">
                        {t('PROFILE_NOTIFICATIONS:TasksTitle')}
                      </h5>
                    </div>
                    <p className="pb-2">
                      {t('PROFILE_NOTIFICATIONS:TasksContent')}
                    </p>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskCreationLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_creation !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_creation', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskCreationContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskUpdateLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_update !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_update', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskUpdateContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskDeletionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_deletion !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_deletion', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskDeletionContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskAssignmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_assignment !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_assignment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskAssignmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskUnAssignmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_unassignment !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_unassignment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskUnAssignmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskConfirmationLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_confirmation !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_confirmation', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskConfirmationContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:TaskRejectionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.task_rejection !== false}
                          onChange={(e) => handleChangeNotificationSetting('task_rejection', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:TaskRejectionContent')}
                      </p>
                    </FormGroup>
                  </Card.Body>
                </Card>
                <Card className="mb-3">
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      <h5 className="card-title mb-3">
                        {t('PROFILE_NOTIFICATIONS:OtherNotificationsTitle')}
                      </h5>
                    </div>
                    <p className="pb-2">
                      {t('PROFILE_NOTIFICATIONS:OtherNotificationsContent')}
                    </p>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:AssistantAssignmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.assistant_assignment !== false}
                          onChange={(e) => handleChangeNotificationSetting('assistant_assignment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:AssistantAssignmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:AssistantUnassignmentLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.assistant_unassignment !== false}
                          onChange={(e) => handleChangeNotificationSetting('assistant_unassignment', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:AssistantUnassignmentContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:ManyTasksArePendingOfConfirmationLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.many_tasks_are_pending_of_confirmation !== false}
                          onChange={(e) => handleChangeNotificationSetting('many_tasks_are_pending_of_confirmation', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:ManyTasksArePendingOfConfirmationContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:WeeklyPPCReportLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.weekly_ppc_report !== false}
                          onChange={(e) => handleChangeNotificationSetting('weekly_ppc_report', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:WeeklyPPCReportContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:WeeklyCNCAnalysisReportLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.weekly_cnc_analisys_report !== false}
                          onChange={(e) => handleChangeNotificationSetting('weekly_cnc_analisys_report', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:WeeklyCNCAnalysisReportContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:AnotherAccountDeletionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.another_account_deletion !== false}
                          onChange={(e) => handleChangeNotificationSetting('another_account_deletion', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:AnotherAccountDeletionContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:ProjectChatAdditionLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.project_chat_addition !== false}
                          onChange={(e) => handleChangeNotificationSetting('project_chat_addition', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:ProjectChatAdditionContent')}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <label className="switch switch-right switch-primary" style={{ paddingLeft: 0, width: '100%' }}>
                        <span style={{ fontWeight: 700, color: '#000' }}>
                          {t('PROFILE_NOTIFICATIONS:ReceivingChatMessagesLabel')}
                        </span>
                        <input className="form-check-input"
                          type="checkbox"
                          checked={notificationsSettings.receiving_chat_messages !== false}
                          onChange={(e) => handleChangeNotificationSetting('receiving_chat_messages', e.currentTarget.checked)}
                          id="defaultCheck1"
                        />
                        <span className="slider" style={{ left: 'auto'}}></span>
                      </label>
                      <p>
                        {t('PROFILE_NOTIFICATIONS:ReceivingChatMessagesContent')}
                      </p>
                    </FormGroup>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab.Pane>
        </Tab.Content>
      </ContentBody>
    </ProjectLayout>
  )
};

export default ProfilePage;
